import React from "react";

const About = () => {
  return (
    <div>
      <section className=" dark:text-gray-100">
        <div className="container flex flex-col justify-center p-6 mx-auto sm:py-12 lg:py-24 lg:flex-row lg:justify-between">
          <div
            data-aos="fade-right"
            data-aos-offset="300"
            data-aos-easing="ease-in-sine"
            className="flex items-center justify-center p-6 mt-8 lg:mt-0 h-72 sm:h-80 lg:h-96 xl:h-112 2xl:h-128"
          >
            
            <div className="avatar ">
              <div className="max-w-lg mask mask-squircle">
                <img
                  src="https://i.ibb.co/VjHYg3g/IMG20221002193545.jpg"
                  alt="Rahul sarker"
                  className="max-w-sm  rounded-full shadow-2xl"
                />
              </div>
            </div>
          </div>
          <div
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"  className="flex flex-col justify-center p-6 text-center rounded-sm lg:max-w-md xl:max-w-lg lg:text-left">
            <p className="mt-6 mb-8 text-lg sm:mb-12">
              I'm   Rohit mondal. I am 16 years old. I'm a student at Mayapur
              Thakur Bhaktivinod Institute. I am completing a web development
              course at Programming Hero. I have a good knowledge of Javascript,
              ES6, React JS, HTML, CSS, Bootstrap, tailwind css for the
              Development of Front-end UI. I have also known Node JS, Express
              JS, MongoDB , Firebase for Backend Development. Now I am studying
              web development daily. I am a deeply dedicated learner and
              interested in new technology.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
